(function () {
  var LOADING_MESSAGE = 'Loading promotion details...';
  var DEFAULT_HEADER = 'Season Savings Only on Eligible Collections';
  var DEFAULT_FALLBACK =
    'Buy More, Save More on Warranties. Select 1 Warranty – Save 10%. Select 2 Warranties – Save 15%. Select 3 Warranties – Save 20% . Select 4+ Warranties – Save 25%. Kitchen Packages & Laundry Pairs – Save 25%.';

  var rebateCache = {};

  function getSettings() {
    var el = document.getElementById('discount-popup-settings');
    if (!el) return { fallbackPromotion: DEFAULT_FALLBACK };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { fallbackPromotion: DEFAULT_FALLBACK };
    }
  }

  function getFallbackPromotion() {
    var settings = getSettings();
    return settings.fallbackPromotion || DEFAULT_FALLBACK;
  }

  function normalizeTitle(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function hasMeaningfulContent(htmlOrText) {
    if (!htmlOrText) return false;
    var text = htmlOrText.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    return text.length > 0;
  }

  function renderPromotion(offerList, descriptionHtml, isLoading) {
    if (isLoading) {
      offerList.innerHTML = '<div class="offer-list__loading">' + LOADING_MESSAGE + '</div>';
      return;
    }

    if (hasMeaningfulContent(descriptionHtml)) {
      offerList.innerHTML = '<div class="offer-list__promo">' + descriptionHtml + '</div>';
      return;
    }

    offerList.innerHTML = '<div class="offer-list__promo">' + getFallbackPromotion() + '</div>';
  }

  function getProductHandle(triggerBtn, productItem) {
    var handle = triggerBtn.getAttribute('data-product-handle');
    if (handle) return handle;

    if (!productItem) return '';

    var link = productItem.querySelector(
      'a.product-item__title[href*="/products/"], a.product-item__image-wrapper[href*="/products/"], a[href*="/products/"]'
    );
    if (!link) return '';

    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readLocalRebateSource(triggerBtn, productItem) {
    var title = '';
    var descriptionHtml = '';
    var sourceEl = productItem ? productItem.querySelector('.product-item__rebate-source') : null;

    if (sourceEl && hasMeaningfulContent(sourceEl.innerHTML)) {
      title = sourceEl.getAttribute('data-rebate-title') || '';
      descriptionHtml = sourceEl.innerHTML;
      return { title: title, descriptionHtml: descriptionHtml };
    }

    var pageSource = document.querySelector('.raw-rebate-source');
    if (pageSource && hasMeaningfulContent(pageSource.innerHTML)) {
      descriptionHtml = pageSource.innerHTML;
      var rebatesInfo = pageSource.closest('.rebates__info');
      if (rebatesInfo) {
        var titleEl = rebatesInfo.querySelector('.rebate__title');
        if (titleEl) title = normalizeTitle(titleEl.textContent);
      }
      return { title: title, descriptionHtml: descriptionHtml };
    }

    return null;
  }

  function parseRebateFromHtml(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var source = doc.querySelector('.raw-rebate-source');

    if (!source || !hasMeaningfulContent(source.innerHTML)) return null;

    var title = '';
    var rebatesInfo = source.closest('.rebates__info');
    if (rebatesInfo) {
      var titleEl = rebatesInfo.querySelector('.rebate__title');
      if (titleEl) title = normalizeTitle(titleEl.textContent);
    }

    return { title: title, descriptionHtml: source.innerHTML };
  }

  function fetchRebateFromProductPage(handle) {
    return fetch('/products/' + encodeURIComponent(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Product page fetch failed');
        return response.text();
      })
      .then(function (html) {
        var data = parseRebateFromHtml(html);
        if (!data) throw new Error('No rebate on product page');
        return data;
      });
  }

  function fetchRebateFromPopupView(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=rebate-popup', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json, text/plain, */*' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Rebate popup view failed');
        return response.text();
      })
      .then(function (text) {
        var data = JSON.parse(text.trim());
        if (!data || !hasMeaningfulContent(data.description)) throw new Error('Empty rebate popup data');
        return {
          title: data.title || '',
          descriptionHtml: data.description
        };
      });
  }

  function fetchRebateData(handle) {
    if (rebateCache[handle]) {
      return Promise.resolve(rebateCache[handle]);
    }

    return fetchRebateFromPopupView(handle)
      .catch(function () {
        return fetchRebateFromProductPage(handle);
      })
      .then(function (data) {
        rebateCache[handle] = data;
        return data;
      });
  }

  function showDiscountPopup(title, descriptionHtml, isLoading) {
    var popup = document.getElementById('discount-popup');
    if (!popup) return;

    var offerList = popup.querySelector('.offer-list');
    var header = popup.querySelector('.popup-header');

    if (header) {
      header.textContent = isLoading ? DEFAULT_HEADER : (title || DEFAULT_HEADER);
    }

    if (offerList) {
      renderPromotion(offerList, descriptionHtml, isLoading);
    }

    popup.style.display = 'flex';
  }

  function openDiscountPopup(triggerBtn) {
    var productItem = triggerBtn ? triggerBtn.closest('.product-item') : null;
    var localData = readLocalRebateSource(triggerBtn, productItem);

    if (localData && hasMeaningfulContent(localData.descriptionHtml)) {
      showDiscountPopup(localData.title, localData.descriptionHtml);
      return;
    }

    var handle = getProductHandle(triggerBtn, productItem);
    if (!handle) {
      showDiscountPopup('', '');
      return;
    }

    showDiscountPopup('', '', true);

    fetchRebateData(handle)
      .then(function (data) {
        showDiscountPopup(data.title, data.descriptionHtml);
      })
      .catch(function () {
        showDiscountPopup('', '');
      });
  }

  document.addEventListener('click', function (e) {
    var popup = document.getElementById('discount-popup');
    if (!popup) return;

    var triggerBtn = e.target.closest('.product-item__extra-discount-btn');
    if (triggerBtn) {
      e.preventDefault();
      openDiscountPopup(triggerBtn);
      return;
    }

    if (e.target.closest('.close-popup') || e.target === popup) {
      popup.style.display = 'none';
    }
  });
})();
